module.exports = __webpack_public_path__ + "img/6.8eda46a0.jpg";